/**
 * Sybotanica locale sync — orb choice → Klaviyo email language.
 * -------------------------------------------------------------
 * When a visitor commits an explicit language/country choice in the geo
 * picker (nf-geo-notice), push the canonical BCP-47 locale (reading-language
 * + country, e.g. en-DE / de-DE / da-DK / en-SE) to their Klaviyo profile via
 * onsite identify. Klaviyo derives $locale_language from $locale and uses it
 * to pick the email language — so a switch to "Denmark · Dansk" on the site
 * makes the next emails Danish.
 *
 * NO BACKEND by design (decided 2026-05-23): a visitor who arrived from a
 * Klaviyo email (or ever subscribed) is already identified onsite, so this
 * updates the right profile directly. Buyers are covered by the native
 * checkout-locale → Klaviyo sync; anonymous-unknown visitors by the signup
 * popups. The only edge not covered (an existing Shopify customer whose
 * periodic Shopify→Klaviyo sync could later revert $locale) self-heals at
 * their next checkout — accepted; the App Proxy would only be needed to make
 * that bulletproof, and was deliberately deferred.
 *
 * HARD RULES: never throw; skip in B2B; only ever call identify (never track
 * PII); idempotent.
 */
(function () {
  'use strict';

  // B2B exclusion — mirrors the other engines (no consumer locale logic on
  // wholesale).
  try {
    if (window.SybotanicaB2B && (window.SybotanicaB2B.isB2B || window.SybotanicaB2B.isB2BPage)) return;
  } catch (e) { /* fall through */ }

  // BCP-47 {lang}-{COUNTRY}: lowercase language, uppercase region.
  var LOCALE_RE = /^[a-z]{2}-[A-Z]{2}$/;
  var lastSent = null;

  function commit(locale) {
    if (!locale || typeof locale !== 'string') return;
    locale = locale.trim();
    if (!LOCALE_RE.test(locale)) return;
    if (locale === lastSent) return; // idempotent within the page
    lastSent = locale;
    try {
      // window.klaviyo is the modern object; _learnq is the legacy queue.
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ '$locale': locale });
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', { '$locale': locale }]);
      }
    } catch (e) { /* never break the picker */ }
  }

  window.SybaLocaleSync = { commit: commit };
})();
